const MONTHS_ES = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

/** "2026-09-18" / ISO → "septiembre 18, 2026" (es-CO, sin corrimiento de zona horaria). */
export function formatBlogDate(value) {
  if (!value) return "";
  const s = String(value);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  let year;
  let month;
  let day;
  if (m) {
    year = Number(m[1]);
    month = Number(m[2]);
    day = Number(m[3]);
  } else {
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return "";
    year = d.getFullYear();
    month = d.getMonth() + 1;
    day = d.getDate();
  }
  if (!MONTHS_ES[month - 1]) return "";
  return `${MONTHS_ES[month - 1]} ${day}, ${year}`;
}

/** Atributo datetime válido para <time>. */
export function blogDateTimeAttr(value) {
  const m = String(value || "").match(/^\d{4}-\d{2}-\d{2}/);
  return m ? m[0] : undefined;
}

const BLOCKED_TAGS = "script, style, object, embed, link, meta, base, form";
/** Solo se permiten videos embebidos de estos orígenes. */
const ALLOWED_IFRAME_SRC =
  /^https:\/\/(www\.)?(youtube\.com|youtube-nocookie\.com|player\.vimeo\.com)\//i;

/**
 * El body_html llega sanitizado desde el backend; aun así se limpia aquí de
 * forma defensiva: sin scripts/iframes/handlers on* ni URLs javascript:, y los
 * enlaces externos abren en pestaña nueva.
 */
export function sanitizeBlogHtml(html) {
  if (!html) return "";
  if (typeof window === "undefined" || typeof window.DOMParser === "undefined") {
    return String(html).replace(/<script[\s\S]*?<\/script>/gi, "");
  }
  const doc = new window.DOMParser().parseFromString(String(html), "text/html");
  doc.querySelectorAll(BLOCKED_TAGS).forEach((el) => el.remove());
  doc.querySelectorAll("iframe").forEach((el) => {
    if (!ALLOWED_IFRAME_SRC.test(el.getAttribute("src") || "")) el.remove();
  });
  doc.body.querySelectorAll("*").forEach((el) => {
    Array.from(el.attributes).forEach((attr) => {
      const name = attr.name.toLowerCase();
      const value = String(attr.value || "").trim().toLowerCase();
      if (name.startsWith("on") || name === "style" || name === "srcdoc") {
        el.removeAttribute(attr.name);
        return;
      }
      if (
        (name === "href" || name === "src" || name === "xlink:href") &&
        /^(?:java|vb)script:|^data:text/.test(value.replace(/\s+/g, ""))
      ) {
        el.removeAttribute(attr.name);
      }
    });
    if (el.tagName === "A") {
      const href = el.getAttribute("href") || "";
      if (/^https?:\/\//i.test(href) && !href.includes(window.location.host)) {
        el.setAttribute("target", "_blank");
        el.setAttribute("rel", "noopener noreferrer");
      }
    }
    if (el.tagName === "IMG") {
      el.setAttribute("loading", "lazy");
      el.setAttribute("decoding", "async");
    }
  });
  return doc.body.innerHTML;
}

/** Enlaces para compartir (fallback cuando no hay navigator.share). */
export function buildShareLinks(url, title) {
  const u = encodeURIComponent(url);
  const text = encodeURIComponent(title ? `${title} ${url}` : url);
  return {
    whatsapp: `https://wa.me/?text=${text}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
    x: `https://twitter.com/intent/tweet?url=${u}&text=${encodeURIComponent(title || "")}`,
  };
}

export async function copyToClipboard(text) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* sigue al método legacy */
  }
  try {
    const area = document.createElement("textarea");
    area.value = text;
    area.setAttribute("readonly", "");
    area.style.position = "fixed";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(area);
    return ok;
  } catch {
    return false;
  }
}

/** Solo rutas internas o http(s) como destino del CTA. */
export function safeCtaUrl(url) {
  const s = String(url || "").trim();
  if (!s) return "";
  if (s.startsWith("/") && !s.startsWith("//")) return s;
  if (/^https?:\/\//i.test(s)) return s;
  return "";
}
